import React from 'react';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import Spinner from 'Shared/components/spinner';
import styles from './notice.css';


type NoticeButton = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  buttonType?: 'action-primary' | 'action-secondary' | 'button-primary' | 'button-secondary';
};

type NoticeProps = {
  svgPath?: string;
  content: React.ReactNode;
  button?: NoticeButton;
  loading?: boolean;
};

const Notice = ({
  svgPath,
  content,
  button,
  loading,
}: NoticeProps) => (
  <div className={styles.container}>
    <div className={styles.contentContainer}>
      {loading
        ? <Spinner customClass={styles.spinner} />
        : (
          <>
            {svgPath && (
              <div className={styles.svgContainer}>
                <InlineSvg src={svgPath} />
              </div>
            )}
            <div className={styles.textContainer}>
              {content}
            </div>
            {button && (
              <div className={styles.buttonContainer}>
                <Button
                  buttonType={button.buttonType ?? 'action-primary'}
                  text={button.text}
                  onClick={button.onClick}
                  attributes={{ disabled: button.disabled }}
                  className={styles.button}
                />
              </div>
            )}
          </>
        )}
    </div>
  </div>
);

export default Notice;
